import { ShieldCheckIcon, LockKeyIcon, CheckCircleIcon } from "@phosphor-icons/react";

const points = [
  "No confidential matter details requested at registration.",
  "No client names, case information or sensitive documents in the form.",
  "Submission data is only collected later inside the secure product environment.",
];

export default function Confidentiality() {
  return (
    <section
      id="confidentiality"
      data-testid="confidentiality-section"
      className="relative py-24 md:py-32 overflow-hidden bg-[#f7f4ec]"
    >
      <div
        aria-hidden="true"
        className="absolute -right-24 -top-10 h-[360px] w-[360px] rounded-full bg-[#ff5e3a]/15 blur-[120px]"
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="sticky top-28">
            <div className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-stone-900 text-[#f7f4ec] mb-6">
              <ShieldCheckIcon size={24} weight="duotone" />
            </div>
            <p className="text-sm uppercase tracking-[0.18em] font-semibold text-stone-500">
              Confidentiality
            </p>
            <h2 className="mt-4 font-heading text-3xl md:text-5xl tracking-tight font-medium text-stone-900 leading-[1.1]">
              Confidentiality is built into the product logic.
            </h2>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="rounded-3xl bg-[#f3efe6]/70 backdrop-blur-xl border border-stone-200 p-8 md:p-10 shadow-sm">
            <p className="text-lg leading-relaxed text-stone-700">
              For early access registration, we will not ask for confidential
              matter details, client names or documents. Actual submission data
              will only be collected through the secure product environment
              once the appropriate privacy, confidentiality and data-processing
              safeguards are in place.
            </p>

            <ul className="mt-8 space-y-4">
              {points.map((p, idx) => (
                <li
                  key={idx}
                  data-testid={`confidentiality-point-${idx}`}
                  className="flex items-start gap-3"
                >
                  <CheckCircleIcon
                    size={22}
                    weight="duotone"
                    className="mt-0.5 text-[#ff5e3a] shrink-0"
                  />
                  <span className="text-stone-800 leading-relaxed">{p}</span>
                </li>
              ))}
            </ul>

            <div className="mt-8 pt-6 border-t border-stone-200 flex items-center gap-3 text-sm text-stone-600">
              <LockKeyIcon size={16} weight="duotone" className="text-stone-700" />
              The early-access form below is structured around lead
              qualification only — never confidential information.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
